import Vue from 'vue'

// Lib imports
import axios from 'axios'
import { data } from '../store/data.module';

Vue.prototype.$http = axios;

Vue.prototype.$axiosHttp = {
    get: async(url, headers) => {

        let responseType = 'json';
        if (headers && headers.Accept !== "application/json") {
            responseType = 'blob';
        }
        var res = await axios.get(url, { headers, responseType });
        return res.data;
    },
    post: async(url, data, headers) => {

        let responseType = 'json';
        if (headers && headers.Accept !== "application/json") {
            responseType = 'blob';
        }
        var res = await axios.post(url, data, { headers, responseType });
        return res.data;
    }
};